import { IImage, Languages } from "@/src/types";
import { graphql, useStaticQuery } from "gatsby";

export type IFooterData = {
  footerBlock1: {
    link1: {
      target: string;
      title: string;
      url: string;
    };
    link2: {
      target: string;
      title: string;
      url: string;
    };
    logo: IImage;
    text: string;
  };
  footerBlock2: {
    text: string;
    title: string;
  };
  footerBlock3: {
    socialMedia: {
      account: {
        target: string;
        title: string;
        url: string;
      };
      icon: IImage;
    }[];
    title: string;
    button: {
      target: string;
      title: string;
      url: string;
    };
    placeholderInput: string;
  };
  footerMenu: {
    menuBlock: {
      linkBlock: {
        link: {
          target: string;
          title: string;
          url: string;
        };
      }[];
      title: {
        target: string;
        title: string;
        url: string;
      };
    }[];
  };
};

const useFooterData = (lang: Languages): IFooterData => {
  const { wp } = useStaticQuery(
    graphql`
      {
        wp {
          siteSettingsSV {
            footer {
              footerBlock1 {
                link1 {
                  target
                  title
                  url
                }
                link2 {
                  target
                  title
                  url
                }
                logo {
                  altText
                  title
                  sizes
                  sourceUrl
                  gatsbyImage(
                    placeholder: NONE
                    width: 2000
                    formats: [AUTO, WEBP]
                    layout: FULL_WIDTH
                  )
                }
                text
              }
              footerBlock2 {
                text
                title
              }
              footerBlock3 {
                socialMedia {
                  account {
                    target
                    title
                    url
                  }
                  icon {
                    altText
                    sizes
                    title
                    sourceUrl
                    gatsbyImage(
                      placeholder: BLURRED
                      width: 2000
                      formats: [AUTO, WEBP]
                      layout: FULL_WIDTH
                    )
                  }
                }
                title
                button {
                  target
                  title
                  url
                }
                placeholderInput
              }
              footerMenu {
                menuBlock {
                  linkBlock {
                    link {
                      target
                      title
                      url
                    }
                  }
                  title {
                    target
                    title
                    url
                  }
                }
              }
            }
          }
          siteSettingsEN {
            footer {
              footerBlock1 {
                link1 {
                  target
                  title
                  url
                }
                link2 {
                  target
                  title
                  url
                }
                logo {
                  altText
                  title
                  sizes
                  sourceUrl
                  gatsbyImage(
                    placeholder: BLURRED
                    width: 2000
                    formats: [AUTO, WEBP]
                    layout: FULL_WIDTH
                  )
                }
                text
              }
              footerBlock2 {
                text
                title
              }
              footerBlock3 {
                socialMedia {
                  account {
                    target
                    title
                    url
                  }
                  icon {
                    altText
                    sizes
                    title
                    sourceUrl
                    gatsbyImage(
                      placeholder: BLURRED
                      width: 2000
                      formats: [AUTO, WEBP]
                      layout: FULL_WIDTH
                    )
                  }
                }
                title
                button {
                  target
                  title
                  url
                }
                placeholderInput
              }
              footerMenu {
                menuBlock {
                  linkBlock {
                    link {
                      target
                      title
                      url
                    }
                  }
                  title {
                    target
                    title
                    url
                  }
                }
              }
            }
          }
          siteSettingsNO {
            footer {
              footerBlock1 {
                link1 {
                  target
                  title
                  url
                }
                link2 {
                  target
                  title
                  url
                }
                logo {
                  altText
                  title
                  sizes
                  sourceUrl
                  gatsbyImage(
                    placeholder: NONE
                    width: 2000
                    formats: [AUTO, WEBP]
                    layout: FULL_WIDTH
                  )
                }
                text
              }
              footerBlock2 {
                text
                title
              }
              footerBlock3 {
                socialMedia {
                  account {
                    target
                    title
                    url
                  }
                  icon {
                    altText
                    sizes
                    title
                    sourceUrl
                    gatsbyImage(
                      placeholder: BLURRED
                      width: 2000
                      formats: [AUTO, WEBP]
                      layout: FULL_WIDTH
                    )
                  }
                }
                title
                button {
                  target
                  title
                  url
                }
                placeholderInput
              }
              footerMenu {
                menuBlock {
                  linkBlock {
                    link {
                      target
                      title
                      url
                    }
                  }
                  title {
                    target
                    title
                    url
                  }
                }
              }
            }
          }
        }
      }
    `
  );
  return wp[`siteSettings${lang.toUpperCase()}`].footer;
};
export default useFooterData;
